function toAreaValue(value) {
  return Number.isInteger(value) ? value : Number(value.toFixed(2));
}

function getScarArea(scar) {
  if (!scar) return 0;

  return Number(scar.answerLength || 0) * Number(scar.answerWidth || 0);
}

function getScarsTotalArea(scars) {
  let totalArea = 0;

  for (let scar of scars || []) {
    totalArea += getScarArea(scar);
  }

  return toAreaValue(totalArea);
}

function getUnderlyingQuestion(question) {
  if (!question || !Array.isArray(question.questions)) return null;

  return question.questions.find((item) => item.isUnderlying);
}

export function updateScarQuestionSelection(question, event) {
  const selectedScar = question.questions[event.index].scars[event.indexSecond];
  selectedScar.answer = selectedScar.answer === "X" ? "" : "X";

  return syncScarQuestionSummary(question, event.scars);
}

export function syncScarQuestionSummary(question, scars) {
  if (!question || question.type !== "scarQuestions" || !question.show) {
    return question;
  }

  const totalArea = Number(getScarsTotalArea(scars));
  const underlyingQuestion = getUnderlyingQuestion(question);
  let underlyingArea = 0;

  for (let i = 0; i < (scars || []).length; i++) {
    if (
      underlyingQuestion &&
      underlyingQuestion.scars[i] &&
      underlyingQuestion.scars[i].answer === "X"
    ) {
      underlyingArea += getScarArea(scars[i]);
    }
  }

  const notUnderlyingArea = totalArea - underlyingArea;

  question.underlying =
    underlyingArea > 0 ? toAreaValue(underlyingArea) : "";
  question.notUnderlying =
    notUnderlyingArea > 0 ? toAreaValue(notUnderlyingArea) : "";

  return question;
}
